import React, {useState} from 'react';
import 'react-spring-bottom-sheet/dist/style.css'
import styled from 'styled-components';
import {Button, Checkbox, FormControl, FormLabel, Input, Select} from "@chakra-ui/react";
import useModal from "../../../modals";
import Sheet, {Header, Title} from "../sheet";
import RoleIndicator from "../../role_indicator";
import {useSheetModal} from "../../test/ModalContext";
import ProCryptoPaymentSheet from "./pro_crypto_payment";
import ProCardPaymentSheet from "./pro_card_payment";
import {themecolors} from "../../../utils/themecolors";

const titles = [
    'Upgrade to Pro',
    'Your Contribution',
    'Payment Method',
    'Payment Cycle'
]

const List = styled.div``;
const ButtonContainer = styled.div``;

const PaymentMethod = styled.div``;
const PaymentTitle = styled.h2``;
const PaymentDescription = styled.div``;
const PaymentText = styled.div``;
const PaymentMethods = styled.div``;

const ProSignupSheet = styled(({className, onClose}) => {

        const [tier, setTier] = useState('');
        const [price, setPrice] = useState(false);

        const [length, setLength] = useState(1);

        const modal = useModal();

        const [paymentMethod, setPaymentMethod] = useState("creditCard");
        const [page, setPage] = useState(1);

        const { openModal } = useSheetModal();

        const handleContinue = async () => {

                if (page === 2 && (price < 6.99 || price > 500)) return;

                if (paymentMethod === "cryptocurrency" && page < 4 || page < 3) {
                    setPage(page + 1);
                } else {
                    if (paymentMethod === "creditCard") {

                        const modalContent = () => (
                            <Sheet onClose={() => {
                                onClose()
                            }}  padding={"header"}><ProCardPaymentSheet type={"subscription"} tier={tier === "basic" ? 1 : 2}
                                                            length={length} overridePrice={price}
                                                            onClose={() => onClose() }/></Sheet>
                        );
                        openModal(modalContent);

                    } else if (paymentMethod === "cryptocurrency") {

                            onClose();

                            const modalContent = ( ) => (
                                <Sheet onClose={() => onClose() }  padding={"header"}><ProCryptoPaymentSheet type={"subscription"} tier={tier === "basic" ? 1 : 2} length={length} subscriptionPrice={price} onClose={() => onClose() } /></Sheet>
                            );
                            openModal(modalContent);

                   }
                }
            }
            const handlePaymentMethod = (value) => {
                setPaymentMethod(value);
            }

        return (
            <div className={className}>

                <Header>
                    <Title>{titles[page-1]}</Title>
                </Header>

                {page === 1 &&
                    <>

                        <p>Contribute at least $6.99 per month to support the platform and to receive Pro.</p>

                        <List>
                            <p>• help us continue to build</p>
                            <p>• get the <RoleIndicator proTier={2} /> badge</p>
                            <p>• go ad-free</p>
                            <p>• receive 1 award credit per month</p>
                                <a target={"_blank"} href={"https://help.scored.co/knowledge-base/about-scored-pro/"}>
                                    • read more about Pro
                                </a>
                        </List>

                    </>
                }
                {page === 2 &&
                    <>
                        <p>
                            Any monthly contribution of $6.99 or greater includes the Pro subscription.
                        </p>

                        <FormControl style={{marginTop: 16}}>
                            <FormLabel fontSize={18}>Your monthly contribution</FormLabel>
                            <Input type="number" value={price} onChange={(e) => setPrice(e.currentTarget.value)}/>
                        </FormControl>
                    </>
                }
                {page === 3 &&
                    <>
                        <PaymentMethod onClick={() => handlePaymentMethod('creditCard') }>
                            <Checkbox size={'lg'} isChecked={paymentMethod === "creditCard"}/>
                            <PaymentText>
                                <PaymentTitle>
                                    Credit Card
                                </PaymentTitle>
                                <PaymentDescription>
                                    Pay using a credit or debit card.
                                </PaymentDescription>
                            </PaymentText>
                        </PaymentMethod>
                        <PaymentMethod onClick={() => handlePaymentMethod('cryptocurrency') }>
                            <Checkbox size={'lg'} isChecked={paymentMethod === "cryptocurrency"} />
                            <PaymentText>
                                <PaymentTitle>
                                    Cryptocurrency
                                </PaymentTitle>
                                <PaymentDescription>
                                    Pay with privacy, using a range of cryptocurrencies.
                                </PaymentDescription>
                            </PaymentText>
                        </PaymentMethod>
                    </>
                }
                {page === 4 && paymentMethod === "cryptocurrency" &&
                    <>
                        <p>
                            Since recurring billing isn't currently viable with cryptocurrency, would you consider paying a longer duration upfront?
                        </p>
                        <Select style={{marginTop: 12}} onChange={(e) => setLength(e.currentTarget.value)}>
                            <option value={1}>No - I'll pay monthly.</option>
                            <option value={3}>Quarterly (3 months - ${price * 3})</option>
                            <option value={6}>Bi-annually (6 months - ${price * 6})</option>
                            <option value={12}>Annually (12 months - ${price * 12})</option>
                        </Select>
                    </>
                }
                <ButtonContainer>
                    <Button variant={"blue"} w={"100%"} onClick={handleContinue}>Next</Button>
                </ButtonContainer>

            </div>
        );
    }
)`
  p {
    font-size: 17px;
    display: flex;
  }

  ${List} {
    margin: 16px 4px 24px 4px;
  }

  ${List} a {
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_high_impact_text : theme.link_1};
  }
  ${ButtonContainer} {
    margin-top: 16px;
  }
   ${PaymentMethod} {
    border: 1px solid ${({theme}) => theme.color.name === 'dark' ? '#343536' : '#f2f2f2'};
    border-radius: 4px;
    padding: 16px;
    margin-bottom: 8px;
    display: flex;
    cursor: pointer;
  }
  ${PaymentMethods} {
    margin: 16px;
  }
  ${PaymentText} {
    padding-left: 16px;
    font-size: 17px;
  }
  ${PaymentDescription} {
    font-size: 15px;
  }
  ${PaymentTitle} {
    margin: 0 !important;
  }
`;

export default ProSignupSheet;
